var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[(_vm.policyUrl)?_c('a',{attrs:{"target":"blank","href":_vm.policyUrl}},[_vm._v("Политика обработки данных")]):_vm._e(),_c('a',{attrs:{"target":"blank","href":_vm.regulationsUrl}},[_vm._v("Пользовательское соглашение")])])
}
var staticRenderFns = []

export { render, staticRenderFns }